// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.4/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.4/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;900&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.2/css/all.min.css);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Bricolage+Grotesque:opsz,wght@12..96,200..800&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  box-sizing: border-box;
}

:root {
  font-family: Inter;
  --color-light-grey: #ccc;
  --color-grey: #777;
  --color-black: #222;
}

html,
body {
  min-height: 100%;
}

body {
  margin: 0;
  color: var(--color-black);
  background-color: #fff;
}

body.theme-dark {
  background-color: var(--color-black);
  color: var(--color-light-grey);
  color-scheme: dark;
}

body.theme-dark select, body.theme-dark input {
  background-color: transparent;
}

textarea:focus, input:focus, input[type]:focus, .uneditable-input:focus {
  border-color: var(--vis-color0);
  box-shadow: none;
  outline: 0 none;
}

.root {
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  padding: 8px 8px 8px 8px;
}

.content {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  min-width: 0;
  min-height: 0;
  overflow: hidden;
  position: relative;
}

/* Toolbar stays fixed height; routed view fills remaining space and scrolls internally */
.content > *:first-child {
  flex-shrink: 0;
}

.content > *:last-child {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  min-height: 0;
  min-width: 0;
  overflow: hidden;
}
`, "",{"version":3,"sources":["webpack://./src/App.module.css"],"names":[],"mappings":"AAIA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,cAAc;EACd,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,yFAAyF;AACzF;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,sBAAsB;EACtB,aAAa;EACb,YAAY;EACZ,gBAAgB;AAClB","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;900&display=swap');\n@import url('https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.2/css/all.min.css');\n@import url('https://fonts.googleapis.com/css2?family=Bricolage+Grotesque:opsz,wght@12..96,200..800&display=swap');\n\n* {\n  box-sizing: border-box;\n}\n\n:root {\n  font-family: Inter;\n  --color-light-grey: #ccc;\n  --color-grey: #777;\n  --color-black: #222;\n}\n\nhtml,\nbody {\n  min-height: 100%;\n}\n\nbody {\n  margin: 0;\n  color: var(--color-black);\n  background-color: #fff;\n}\n\nbody.theme-dark {\n  background-color: var(--color-black);\n  color: var(--color-light-grey);\n  color-scheme: dark;\n}\n\nbody.theme-dark select, body.theme-dark input {\n  background-color: transparent;\n}\n\ntextarea:focus, input:focus, input[type]:focus, .uneditable-input:focus {\n  border-color: var(--vis-color0);\n  box-shadow: none;\n  outline: 0 none;\n}\n\n.root {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: row;\n  padding: 8px 8px 8px 8px;\n}\n\n.content {\n  display: flex;\n  flex: 1 1 auto;\n  flex-direction: column;\n  min-width: 0;\n  min-height: 0;\n  overflow: hidden;\n  position: relative;\n}\n\n/* Toolbar stays fixed height; routed view fills remaining space and scrolls internally */\n.content > *:first-child {\n  flex-shrink: 0;\n}\n\n.content > *:last-child {\n  display: flex;\n  flex: 1 1 auto;\n  flex-direction: column;\n  min-height: 0;\n  min-width: 0;\n  overflow: hidden;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"themeDark": `theme-dark`,
	"uneditableInput": `uneditable-input`,
	"root": `root`,
	"content": `content`
};
export default ___CSS_LOADER_EXPORT___;
